import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { hostsApi } from '../../api/lib/hosts';
import { hostsKeys } from '../../api/query-keys/hosts';
import { Host } from '../../api/types/host';

import { PaginatedResponse } from '@/types/responses/paginated-response';

export const useHostsWithSearch = ({
  page,
  perPage,
  email,
  billingGroupId,
  destinationGroupId,
}: {
  page: number;
  perPage: number;
  email?: string;
  billingGroupId?: string;
  destinationGroupId?: string;
}) => {
  return useQuery<PaginatedResponse<Host>, ApiError>({
    queryKey: hostsKeys.list({
      page,
      perPage,
      email,
      billingGroupId,
      destinationGroupId,
    }),
    queryFn: () =>
      hostsApi.fetchHostWithSearch({
        page,
        perPage,
        email,
        billingGroupId,
        destinationGroupId,
      }),
  });
};
